import type { ForqFeatureManifest, ForqModuleManifest } from '@forq/contracts';

export const ordersModule: ForqModuleManifest = {
  id: 'orders',
  name: 'Vorgänge',
  description: 'Vorgänge erstellen, bearbeiten, zuweisen und bis zum Abschluss steuern',
  version: '0.1.0',
  route: '/vorgaenge',
  category: 'operations',
  status: 'development',
  requiredPermissions: ['orders.view'],
  features: [
    'orders.list',
    'orders.create',
    'orders.workbench',
    'orders.status',
  ],
  navigation: [
    { id: 'orders.primary', label: 'Vorgänge', route: '/vorgaenge', placement: 'primary', order: 20, icon: 'vorgaenge' },
    { id: 'orders.launcher', label: 'Vorgänge', route: '/vorgaenge', placement: 'launcher', order: 20, icon: 'vorgaenge' },
  ],
};

export const ordersFeatures: readonly ForqFeatureManifest[] = [
  {
    id: 'orders.list', moduleId: 'orders', name: 'Vorgangsliste',
    description: 'Neue, laufende und abgeschlossene Vorgänge getrennt darstellen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['orders.view'], uiSlots: [], emits: ['orders.order.opened'], listensTo: ['tenant.changed'],
  },
  {
    id: 'orders.create', moduleId: 'orders', name: 'Vorgang erstellen',
    description: 'Geführte Kopfdatenaufnahme und Workbench öffnen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['orders.create'], uiSlots: [], emits: ['orders.order.created'], listensTo: ['sales.handoff.created'],
  },
  {
    id: 'orders.workbench', moduleId: 'orders', name: 'Vorgangs-Workbench',
    description: 'Tastaturoptimierte Positionserfassung, Adressen und Konditionen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['orders.edit'], uiSlots: [], emits: ['orders.order.changed'], listensTo: ['masterdata.item.changed'],
  },
  {
    id: 'orders.status', moduleId: 'orders', name: 'Statussteuerung',
    description: 'Zulässige Statuswechsel, Historie und Abrechnungsbereitschaft', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['orders.view'], uiSlots: [], emits: ['orders.status.changed', 'orders.billing.requested'], listensTo: [],
  },
];
